module.exports.Directive = function() {
  return {
    restrict: "E",
    scope: {},
    templateUrl: "/modules/app/app.view.html"
  };
};
